import React from 'react';

import { SupervisorAccountOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { ActionItemKeys } from '@uplift/api';
import { trackToDoCTA } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { LinkDashboardActionItem } from '@uplift/ui-v2';
import { ROUTING_CONFIG } from '@uplift/constants';


export type ChartsReviewPendingToDoProps = {
  chartsReviewsCount: number;
};


export const ChartsReviewPendingToDo: React.VFC<ChartsReviewPendingToDoProps> = ({ chartsReviewsCount }) => {
  return (
    <LinkDashboardActionItem
      title={<Typography>You have <strong>{chartsReviewsCount} charts review{chartsReviewsCount > 1 ? 's' : ''}</strong> to complete across your supervised providers</Typography>}
      color="warning"
      icon={<SupervisorAccountOutlined />}
      link={ROUTING_CONFIG.chartsReviews}
      actionText="Manage"
      onClick={() => {
        trackToDoCTA({
          toDoType: ActionItemKeys.PROVIDER_CHARTS_REVIEWS_PENDING,
          userType: UserRole.provider
        });
      }}
    />
  );
};
